module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.merchandises) ? _c('div', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('button', {
    staticClass: "button button-link button-nav pull-left"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left goback",
    staticStyle: {
      "font-size": ".8rem"
    },
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), (!_vm.isWapp) ? _c('span', {
    staticClass: "goback",
    staticStyle: {
      "margin-left": "4rem"
    }
  }, [_vm._v("\n           产品详情\n        ")]) : _c('span', {
    staticClass: "goback",
    staticStyle: {
      "margin-left": "7rem"
    }
  }, [_vm._v("\n           产品详情\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, [_c('div', {
    staticClass: "page-detail"
  }, [(_vm.merchandises.specialAnnouncement) ? _c('div', {
    staticStyle: {
      "margin-left": "1rem",
      "font-size": ".6rem",
      "color": "red"
    }
  }, [_vm._v("\n          注：" + _vm._s(_vm.merchandises.specialAnnouncement) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "color": "#0894ec",
      "margin-left": "1rem"
    }
  }, [(_vm.merchandises.showpromotion && _vm.merchandises.showpromotion.length > 0) ? _c('div', {
    staticClass: "item-title-row"
  }, [(_vm.merchandises.showpromotion[0].name !== '') ? _c('div', {
    staticStyle: {
      "color": "slateblue",
      "font-size": "0.6rem",
      "margin-left": "0.2rem"
    }
  }, [_vm._v("参与促销：\n              "), _vm._l((_vm.merchandises.showpromotion), function(proo, index) {
    return _c('div', [(proo.type === 1 && proo.description !== '') ? _c('span', [_vm._v("\n                 " + _vm._s(index + 1) + ": " + _vm._s(proo.description) + "\n                ")]) : (proo.type === 6 && proo.description !== '') ? _c('span', [_vm._v("\n                 " + _vm._s(index + 1) + ": " + _vm._s(proo.description) + "\n                ")]) : _vm._e()])
  })], 2) : _vm._e()]) : _c('div', [(_vm.merchandises.bpromotions && _vm.merchandises.bpromotions.length > 0) ? _c('div', {
    staticClass: "item-title-row"
  }, [(_vm.merchandises.bpromotions[0].name !== '') ? _c('div', {
    staticStyle: {
      "color": "slateblue",
      "font-size": "0.6rem",
      "margin-left": "0.2rem"
    }
  }, [_vm._v("参与促销：\n              "), _vm._l((_vm.merchandises.bpromotions), function(proo, index) {
    return _c('div', [(proo.type === 1 && proo.description !== '') ? _c('span', [_vm._v("\n                 " + _vm._s(index + 1) + ": " + _vm._s(proo.description) + "\n                ")]) : (proo.type === 6 && proo.description !== '') ? _c('span', [_vm._v("\n                 " + _vm._s(index + 1) + ": " + _vm._s(proo.description) + "\n                ")]) : _vm._e()])
  })], 2) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-block",
    staticStyle: {
      "margin-top": "-.75rem"
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab-detail"
    }
  }, [_c('div', {
    staticClass: "list-block"
  }, [(_vm.merchandises.categoryId === 20) ? _c('ul', {
    staticStyle: {
      "border-top": "0 solid"
    }
  }, [_vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== 214 && attribute.value !== '214' && attribute.valueText !== undefined && attribute.groupId === 1) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "merchandises": _vm.merchandises,
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-left": "0.7rem",
      "margin-right": "0.1rem",
      "border": "0.5px solid #e7e7e7"
    }
  }), _vm._v(" "), _vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== 214 && attribute.value !== '214' && attribute.valueText !== undefined && attribute.value !== null && attribute.groupId === 2) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "merchandises": _vm.merchandises,
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== 214 && attribute.valueText !== undefined && attribute.value !== '214' && attribute.groupId === 3) ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "merchandises": _vm.merchandises,
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "param:": _vm.$route.params.merchandises,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("周期")]), _vm._v(" "), (_vm.merchandises.workdays) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.workdays) + "个工作日")]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.cycle) + "个工作日")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("价格")]), _vm._v(" "), (_vm.merchandises.priceMax !== undefined) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.priceMax))]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.price))])])]), _vm._v(" "), (_vm.merchandises.priceMin !== undefined) ? _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("科研终端用户优惠价")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.priceMin))])])]) : _vm._e(), _vm._v(" "), (_vm.showSecPromotionInfo()) ? _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.numRequiredForSecPromotion) + "件秒杀折扣")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.secPromotionRatio) + "折")])])]) : _vm._e()], 2) : _c('ul', {
    staticStyle: {
      "border-top": "0 solid"
    }
  }, [_vm._l((_vm.merchandises._attributesList), function(attribute, index) {
    return (attribute.displayable !== 0 && attribute.value !== -1 && attribute.value !== '-1' && attribute.value !== '' && attribute.value !== '214' && attribute.valueText !== undefined && attribute.columnName !== 'GeneInfo') ? _c('li', {
      staticClass: "item-content"
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "attribute": attribute,
        "merchandises": _vm.merchandises,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "attributesList": _vm.merchandises._attributesList
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("周期")]), _vm._v(" "), (_vm.merchandises.workdays) ? _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.workdays) + "个工作日")]) : _c('div', {
    staticClass: "item-after"
  }, [_vm._v(_vm._s(_vm.merchandises.cycle) + "个工作日")])])]), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner "
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("价格")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.price))])])])], 2), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab ",
    attrs: {
      "id": "tab-introduce"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.introduces)
    }
  }), _vm._v(" "), (_vm.merchandises.manualFileName) ? _c('div', [(_vm.introduces === '') ? _c('div', [_vm._v(_vm._s(_vm.merchandises.description))]) : _vm._e(), _vm._v(" "), (_vm.merchandises.manualFileName.split(';').length === 1) ? _c('div', [_c('div', {
    staticStyle: {
      "color": "#0A7CE3"
    },
    on: {
      "click": function($event) {
        return _vm.gotomanual(_vm.merchandises.manualFileName)
      }
    }
  }, [_vm._v("查看商品手册")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.merchandises.manualFileName.split(';')), function(manualFileName, index) {
    return (_vm.merchandises.manualFileName.split(';').length !== 1) ? _c('div', [_c('div', {
      staticStyle: {
        "color": "#0A7CE3"
      },
      on: {
        "click": function($event) {
          return _vm.gotomanual(manualFileName)
        }
      }
    }, [_vm._v("查看商品手册" + _vm._s(index + 1))]), _vm._v(" "), (_vm.showmanul) ? _c('pdf-preview', {
      attrs: {
        "url": _vm.manualurl + manualFileName
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab ",
    attrs: {
      "id": "tab-qualityCommitment"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.qualityCommitment)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    staticStyle: {
      "margin-left": "0rem"
    },
    attrs: {
      "id": "tab-comments"
    }
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [(_vm.Comments.length > 0) ? _c('ul', _vm._l((_vm.Comments), function(comment) {
    return _c('li', [_c('div', {
      staticClass: "item-content"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(comment.customerName))]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_vm._v(_vm._s(comment.createDT.split(' ')[0]))])]), _vm._v(" "), _c('div', _vm._l((comment.commentLevel), function(index) {
      return _c('span', {
        staticClass: "icon icon-star star",
        staticStyle: {
          "background-color": "yellow",
          "margin-left": "0.2rem"
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(comment.comments))])])])])
  }), 0) : _c('div', [_vm._v("\n                  暂无用户评价！\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    staticStyle: {
      "margin-left": "0rem"
    },
    attrs: {
      "id": "tab-tlnoImg"
    }
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [(_vm.tlnoimgurl !== '') ? _c('div', [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.tlnoimgurl
    }
  })]) : _c('div', [_vm._v("\n                   无载体！\n                ")])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title",
    staticStyle: {
      "color": "gray",
      "font-size": ".7rem"
    }
  }, [_vm._v("产品规格")]), _vm._v(" "), _c('div', {
    staticClass: "item-after",
    staticStyle: {
      "background-color": "#E1E1E4"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "font-size": ".4rem",
      "margin-left": ".5rem",
      "color": "gray"
    }
  }, [_vm._v("\n\n                    不同产品分装规则说明\n                    "), _c('div', [_vm._v("\n                      1.菌液:200μL/tube*1\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      2.质粒:不分装\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      3.慢病毒:50μL/tube\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                      4.腺病毒:200μL/tube\n                    ")]), _c('div', [_vm._v("\n                    5.逆转录病毒:50μL/tube\n                  ")]), _vm._v(" "), _c('div', [_vm._v("\n                      6.腺相关病毒:50μL/tube\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('img', {
    attrs: {
      "src": "/emktResources/resocurces/img/user.jpg",
      "width": "50"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-585e7458","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupProgress/FinderMerchandiseDetailForGR.vue
// module id = 1645
// module chunks = 8